export enum TipoDetalheCotacao {
  COBERTURA = "COBERTURA",
  ASSISTENCIA = "ASSISTENCIA",
}
